// libraries.
import { useDispatch } from 'react-redux';

// components.
import { ButtonSidebar } from '@shared';

// assets.
import { IconIntersections } from '@assets/icons';

// slices.
import { selectSidebarButton } from '@shared/Sidebar/store/slices/sidebar-slice';

// interfaces.
import { SidebarPolygonTool } from '../../../interfaces/sideBar.types';

export const ButtonAuditIntersections = () => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(selectSidebarButton(SidebarPolygonTool.auditIntersections));
  };

  return (
    <ButtonSidebar
      icon={<IconIntersections width="20" height="20" />}
      text="Auditar intersecciones"
      onClick={handleClick}
    />
  );
};
